import {
  CheckIcon,
  ClockIcon,
  XMarkIcon as CancelIcon,
} from "@heroicons/react/20/solid"

interface SwapPillProps {
  bgColor: string
  textColor: string
  borderColor: string
  icon: "clock" | "check" | "cancel"
  text: string
}

export const SwapPill = ({
  bgColor,
  textColor,
  borderColor,
  icon,
  text,
}: SwapPillProps) => {
  return (
    <div
      className="flex items-center gap-1.5 px-2 py-1 rounded text-xs font-medium border-l-2 w-full font-circular my-2"
      style={{
        backgroundColor: bgColor,
        color: textColor,
        borderColor: borderColor,
      }}
    >
      {icon === "clock" && <ClockIcon className="w-4 h-4" />}
      {icon === "check" && <CheckIcon className="w-4 h-4" />}
      {icon === "cancel" && <CancelIcon className="w-4 h-4" />}
      <span>{text}</span>
    </div>
  )
}
